import { getAxios, postAxios } from '../util/service'

//获取cart list
export function getCartList(params, version){
    const data = postAxios(`https://shoppingcart.dhgate.com/checkout/cartSplit/getCartxProductListInCart.do?client=pc${version === 'v2' ? '&newCartMix=1' : ''}`, params)
    return data
}

//修改购买量
export function modifyQuantity(params, version) {
    const data = postAxios(`https://shoppingcart.dhgate.com/checkout/cartSplit/updateQuantity.do?client=pc${version === 'v2' ? '&newCartMix=1' : ''}`, params)
    return data
}

//remove 操作
// type为1，cartList删除
// type为2，saveforlater删除
// mixType为1，混批
// mixType为2，不混批
export function removeItem(params, version) {
    const data = postAxios(`https://shoppingcart.dhgate.com/checkout/cartSplit/newRemove.do?client=pc${version === 'v2' ? '&newCartMix=1' : ''}`, params)
    return data
}

//勾选框接口
export function checkStatus(params, version) {
    const data = postAxios(`https://shoppingcart.dhgate.com/checkout/cartSplit/checkCart.do?client=pc${version === 'v2' ? '&newCartMix=1' : ''}`, params)
    return data
}

//获取Total价格
export function getTotalPrice(params) {
    const data = postAxios('https://shoppingcart.dhgate.com/checkout/cartSplit/getTotalPrice.do?client=pc', params)
    return data
}

//加购
export function addToCart(params) {
    const data = getAxios('https://shoppingcart.dhgate.com/cart/addToCartForSearchJson.do', params)
    return data
}

//获取购物车数量
export function getCartNum(params) {
    const data = getAxios(`https://shoppingcart.dhgate.com/checkout/cartSplit/cartInfo.do?client=pc&buyerId=${params.buyerId}&cartsid=${params.cartsid}`)
    return data
}

//提交购物车
export function submitCart(params) {
  const data = postAxios('https://shoppingcart.dhgate.com/checkout/orderSplit/order/toPlaceOrder.do?client=pc', params)
  return data
}
